import React from "react";
import moment from "moment";
import { Row, Col, Table, Image } from 'react-bootstrap';
import Barcode from 'react-barcode';
import { COLOR_APP, COLOR_WHITE, S3_URL } from '../../constants';
import logoMain from "../../image/logo_main.png";
import QRCode from "react-qr-code";
import { checkLogoLogictics, convertLogicticsName, convertPriceWithCommission, numberFormat } from '../../helpers';
import _ from "lodash";
import { billReceiverAddress, billReceiverBranch, billReceiverName, billReceiverTel, billSenderAddress, billSenderBranch, billSenderName, billSenderTel, billShipments, billShipmentPayType, billCodNumber, billCodAmount, billShippingFee, billTotalAmount, BILL_SHIPMENT_PAY_TYPE_LABEL } from "./billDestination";
export default class BillOrder100x150_V2 extends React.PureComponent {
    render() {
        const { data: orderDatas, rateData } = this.props;
        const ITEMS_PER_PAGE = 10;

        if (_.isEmpty(orderDatas)) return <p>Not Data...!!</p>

        return (
            <div>
                {orderDatas.map((item, index) => {
                    const totalPages = Math.ceil(item?.orders.length / ITEMS_PER_PAGE);

                    return Array.from({ length: totalPages }).map((_, pageIndex) => {
                        const startIndex = pageIndex * ITEMS_PER_PAGE;
                        const endIndex = startIndex + ITEMS_PER_PAGE;
                        const currentOrders = item?.orders.slice(startIndex, endIndex);
                        // console.log("orderdelivery: -> ",item?.orderDelivery)

                        return (
                            <div key={`${index}-${pageIndex}`} style={styles.sectionStyle}>
                                {/* Logistics Section */}
                                {this.renderLogistics(item)}

                                {/* Order Information */}
                                {/* {this.renderOrderInfo(item)} */}

                                {/* Header Section */}
                                {this.renderHeader(item)}

                                <hr />
                                <Row>
                                    <Col>
                                        <div style={{ padding: 10, fontSize: 28, fontWeight: 'bold', color: "#333", opacity: 0.8 }}>
                                            {BILL_SHIPMENT_PAY_TYPE_LABEL[billShipmentPayType(item)]}
                                        </div>
                                        {billCodNumber(item) && (
                                            <p style={{ paddingLeft: 10, fontSize: 25, fontWeight: 'bold' }}>ລະຫັດ COD: {billCodNumber(item)}</p>
                                        )}
                                        <div style={{ padding: 8 }}>
                                            <p style={{ fontSize: 23 }}>{moment(item?.orderDelivery?.createdAt).format('DD/MM/YYYY HH:mm')}</p>

                                            <p style={{ fontSize: 23 }}>
                                                {Array.isArray(item?.orderDelivery?.parcels) && item?.orderDelivery?.parcels.length > 0
                                                    ? `${item?.orderDelivery?.parcels[0].width ?? 1}x${item?.orderDelivery?.parcels[0].length ?? 1}x${item?.orderDelivery?.parcels[0].height ?? 1}cm | ${item?.orderDelivery?.parcels[0].weight ?? 1}kg`
                                                    : '1x1x1cm | 1kg'}
                                            </p>

                                        </div>
                                    </Col>
                                    <Col>
                                        <div style={{ display: 'flex', paddingTop: 10, flexDirection: 'column', justifyContent: 'center', alignItems: 'end', width: '100%', borderLeft: "2px solid #777" }}>
                                            <p style={{ fontSize: 28, fontWeight: 'bold', width: 340, display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>ເງິນຝາກ: {billShippingFee(item) > 0 ? numberFormat(billShippingFee(item)) : "......................."} ກີບ</p>
                                            <p style={{ fontSize: 28, fontWeight: 'bold', width: 340, display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>
                                                COD: {numberFormat(billCodAmount(item))} ກີບ</p>
                                            <p style={{ fontSize: 28, fontWeight: 'bold', width: 340, display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>ເງິນລວມ: {billTotalAmount(item) > 0 ? numberFormat(billTotalAmount(item)) : "......................."} ກີບ</p>
                                        </div>
                                    </Col>
                                </Row>
                                <hr />
                                <h6 style={{ opacity: 0.5 }}>ໝາຍເຫດ: ຄ່າຝາກນີ້ບໍ່ແນ່ນອນ ບາງທິອາດຈະມີການປ່ຽນແປງໄປຕາມຂົນສົ່ງຄິດໄລ່ໃຫ້</h6>


                            </div>
                        );
                    });
                })}
            </div>
        );
    }

    renderHeader(item) {
        return (
            <div className="mb-3 d-flex justify-content-between align-items-center" style={{ borderTop: '2px solid #778', padding: '8px 0' }}>
                <Table>
                    <thead>
                        <tr>
                            <th style={styles?.textSmallV2}>No</th>
                            <th style={styles?.textSmallV2}>ສິນຄ້າ</th>
                            <th style={styles?.textSmallV2}>ລະຫັດ cf</th>
                            <th style={styles?.textSmallV2}>ຈໍານວນ</th>
                            <th style={styles?.textSmallV2}>ເປັນເງິນ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item?.orders?.map((_item, _index) => (
                            <tr key={_index}>
                                <td style={styles?.textSmallV2}>{_index + 1}</td>
                                <td style={styles?.textSmallV2}>{_item?.productName ?? "-"}</td>
                                <td style={styles?.textSmallV2}>{_item?.cfMessage ?? "-"}</td>
                                <td style={styles?.textSmallV2}>{_item?.amount ?? "-"}</td>
                                <td style={styles?.textSmallV2}>{numberFormat(_item?.totalPrice ?? 0)} {_item?.currency ?? ""}</td>
                            </tr>
                        ))}
                        <tr  >
                            <td style={styles?.textSmall} colSpan={4} className="text-right">ຍອດອໍເດີ້ບໍ່ລວມຄ່າຂົນສົ່ງ:</td>
                            <td style={styles?.textSmall}>{numberFormat(item?.totalPrice ?? 0)} ກີບ</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        );
    }

    renderOrderInfo(item) {
        return (
            <div className="w-100 d-flex justify-content-between">
                <div>
                    <p style={styles.textLarge}>ເລກບິນ:</p>
                    <p style={styles.textSmall}>ວັນທີ,ເດືອນ,ປີ:</p>
                </div>
                <div className="d-flex justify-content-center align-items-end flex-column">
                    <p style={styles.textLarge}>{item?.code}</p>
                    <p style={styles.textSmall}>{moment(item?.createdAt).format('DD/MM/YYYY HH:mm')}</p>
                </div>
            </div>
        );
    }

    renderTotal(item, taxPrice, shopRate) {
        return (
            <tr>
                <td style={styles.totalLabel}>ຍອດລວມ</td>
                <td colSpan={2} style={styles.totalAmount}>
                    ₭{numberFormat(convertPriceWithCommission(item?.totalPrice, item?.sumPriceBaht, item?.sumPriceUsd, taxPrice, shopRate))}
                </td>
            </tr>
        );
    }

    renderLogistics(item) {
        const shippMentsBody = billShipments(item)
        return (
            <div>
                <div className="d-flex justify-content-between mt-3">
                    {item?.orderDelivery?.delivery && <div className="d-flex flex-column justify-content-center align-items-center">
                        <Image
                            src={checkLogoLogictics(item?.orderDelivery?.delivery)}
                            style={styles.imageStyle} roundedCircle />
                        <p style={{ fontSize: 28 }}>{convertLogicticsName(item?.orderDelivery?.delivery)} ຂົນສົ່ງດ່ວນ</p>
                    </div>
                    }
                    <div style={styles.barcodeContainer}>
                        <Barcode value={item?.orderDelivery?.deliveryTackingNo ?? "xxxx-xxxx-xxx"} height={110} fontSize={32} />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <Image src={logoMain} alt="brand-logo" style={{ width: 125, height: 125, border: '1px solid #ddd', borderRadius: 25 }} />
                        <p style={{ fontSize: 28 }}>Super CF</p>
                    </div>
                </div>

                <div className="d-flex">
                    <div style={{ borderTop: '2px solid #778', width: '100%' }}>
                        <p style={styles.textLarge}>ຜູ້ຝາກ: {billSenderName(item, this.props.shopData, this.props.shopAddresses)}</p>
                        <p style={styles.textLarge}>ເບີໂທ: {billSenderTel(item, this.props.shopData, this.props.shopAddresses)}</p>
                        <p style={styles.textLarge}>ທີ່ຢູ່: {billSenderAddress(item, this.props.shopData, this.props.shopAddresses)}</p>
                        <p style={styles.textLarge}>ຕົ້ນທາງ: {billSenderBranch(item, this.props.shopData, this.props.shopAddresses)}</p>
                    </div>
                    <div style={{ borderTop: '2px solid #778', borderLeft: '2px solid #778', width: '100%', paddingLeft: 5 }}>
                        <p style={styles.textLarge}>ຜູ້ຮັບ: {billReceiverName(item)}</p>
                        <p style={styles.textLarge}>ເບີໂທ: {billReceiverTel(item)}</p>
                        <p style={styles.textLarge}>ທີ່ຢູ່: {billReceiverAddress(item)}</p>
                        <p style={styles.textLarge}>ລະຫັດສາຂາ: {shippMentsBody?.dropship_end_code ?? "...."}</p>
                        <div className="d-flex justify-content-between align-items-center w-100" style={{ background: "#333", color: COLOR_WHITE, }}>
                            <p style={{ padding: 10, fontWeight: 'bold', fontSize: 35 }}>
                                ປາຍທາງ: {billReceiverBranch(item)}
                            </p>
                            <p style={{ padding: 10, fontWeight: 'bold', fontSize: 35 }}>
                                {shippMentsBody?.warehouse_end_code ?? ""}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

const styles = {
    sectionStyle: { breakInside: "avoid", padding: '3em' },
    imageStyle: { width: 125, height: 125, border: '1px solid #ddd' },
    tableStyle: { minHeight: "26vh" },
    tableHeader: { padding: 4, fontSize: 28 },
    tableData: { fontSize: 28, padding: 4 },
    textLarge: { fontSize: 28 },
    textSmall: { marginTop: '-.5em', fontSize: 25 },
    textSmallV2: { fontSize: 20 },
    totalLabel: { fontSize: 40, fontWeight: 'bold' },
    totalAmount: { textAlign: 'right', paddingTop: 10, fontSize: 40, fontWeight: 'bold' },
    barcodeContainer: { maxWidth: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: "center" },
    logisticsTitle: { fontSize: 28, fontWeight: 'bold' },
    routeTitle: { fontSize: 40 },
    headerTitle: { fontSize: 40, fontWeight: 'bold' },
};

